export const platforms = {
  MOBILE: 'MOBILE',
  WEB: 'WEB'
};
export const channels = {
  MSITE: 'MSITE',
  DESKTOP: 'DESKTOP'
};
export const navigationTypes = {
  HEADER: 'HEADER',
  FOOTER: 'FOOTER',
  SIDE_BAR: 'SIDE_BAR',
  BOTTOM_BAR: 'BOTTOM_BAR',
  TOP_BAR: 'TOP_BAR',
  BOTTOM_BAR_2: 'BOTTOM_BAR_NAV_2.0',
  TOP_BAR_2: 'TOP_BAR_NAV_2.0',
  CATEGORIES: 'CATEGORIES'
};
